import { render, staticRenderFns } from "./AddKeyword.vue?vue&type=template&id=0444f040&scoped=true&"
import script from "./AddKeyword.vue?vue&type=script&lang=js&"
export * from "./AddKeyword.vue?vue&type=script&lang=js&"
import style0 from "./AddKeyword.vue?vue&type=style&index=0&id=0444f040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0444f040",
  null
  
)

component.options.__file = "AddKeyword.vue"
export default component.exports